import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useViewport } from "../../common/hooks/ViewPort";
import ListRow from "src/components/atoms/ListRow/ListRow";
import { PageContainer } from "src/components/organisms/contents";
import { SubConHeader } from "src/components/atoms/SubHeaderBox/SubConHeader";
import { ModalRegister } from "src/components/molecules/ModalRegister";
import { Terms } from "../register/components/Terms";

const PolicyPage: React.FC = () => {
  const navi = useNavigate();
  const { px } = useViewport();
  // const log = (msg: string) => () => console.log(`[Poli cy] ${msg}`);
  const [modalShow, setModalShow] = useState<boolean>(false);
  const [modalLabel, setModalLabel] = useState<string>("");
  const [termId, setTermId] = useState<string>("");

  return (
    <PageContainer isNavBar={false} active={null}>
      <>
        {/* 헤더 */}
        <SubConHeader
          title="약관 및 정책"
          onClickArrow={() => navi("/myinfo")}
        />

        {/* 리스트 카드 */}
        <div
          style={{
            marginTop: px(12),
            background: "#FFFFFF",
            borderRadius: px(14),
            boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
            overflow: "hidden",
          }}
        >
          {/* <ListRow
            label="서비스 이용약관"
            onClick={log("탭: 서비스 이용약관")}
            px={px}
            boldT={true}
          /> */}
          {/* <div style={{ height: 1, background: "#F1F2F4" }} /> */}
          <ListRow
            label="개인정보 수집 및 이용 동의"
            onClick={() => {
              setModalLabel("개인정보 수집 및 이용 동의");
              setTermId("personal");
              setModalShow(true);
            }}
            px={px}
            boldT={true}
          />
          {/* <div style={{ height: 1, background: "#F1F2F4" }} /> */}
          <ListRow
            label="건강정보 처리 및 분석 동의"
            onClick={() => {
              setModalLabel("건강정보 처리 및 분석 동의");
              setTermId("health");
              setModalShow(true);
            }}
            px={px}
            boldT={true}
          />
          {/* <div style={{ height: 1, background: "#F1F2F4" }} /> */}
          <ListRow
            label="마이데이터 기반 활용 동의"
            onClick={() => {
              setModalLabel("마이데이터 기반 활용 동의");
              setTermId("mydata");
              setModalShow(true);
            }}
            px={px}
            boldT={true}
          />
          {/* <div style={{ height: 1, background: "#F1F2F4" }} /> */}
          <ListRow
            label="마케팅 정보 수신 동의"
            onClick={() => {
              setModalLabel("마케팅 정보 수신 동의");
              setTermId("mkt");
              setModalShow(true);
            }}
            px={px}
            boldT={true}
          />
        </div>

        {modalShow && (
          <ModalRegister
            title={modalLabel}
            text={<Terms termsId={termId} />}
            setModalShow={setModalShow}
            btnOff={false}
          />
        )}
      </>
    </PageContainer>
  );
};

export default PolicyPage;
